import { createSignal } from 'solid-js';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface Toast {
  id: string;
  message: string;
  type: ToastType;
  duration?: number;
  title?: string;
  subtitle?: string;
  actions?: ToastAction[];
}

const [toasts, setToasts] = createSignal<Toast[]>([]);

/**
 * Add a new toast notification
 */
export const addToast = (
  message: string,
  type: ToastType = 'info',
  duration: number = 3000,
  options?: {
    title?: string;
    subtitle?: string;
    actions?: ToastAction[];
  }
) => {
  const id = Date.now().toString();
  const toast: Toast = {
    id,
    message,
    type,
    duration,
    title: options?.title,
    subtitle: options?.subtitle,
    actions: options?.actions,
  };

  setToasts((prev) => [...prev, toast]);

  // Auto-remove after duration
  if (duration > 0) {
    setTimeout(() => {
      removeToast(id);
    }, duration);
  }

  return id;
};

/**
 * Remove a toast by ID
 */
export const removeToast = (id: string) => {
  setToasts((prev) => prev.filter((toast) => toast.id !== id));
};

/**
 * Clear all toasts
 */
export const clearToasts = () => {
  setToasts([]);
};

/**
 * Get toasts signal
 */
export const getToastsSignal = () => toasts;

export default {
  addToast,
  removeToast,
  clearToasts,
  getToastsSignal,
};
